import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_ImageEditor.scss'
import AvatarEditor from 'react-avatar-editor'
import FontAwesome from 'react-fontawesome'
import FileUploader from '../forms/FileUploader'
import EditButton from '../forms/EditButton'
import { Row, Col, Form } from 'react-bootstrap'
import PropTypes from 'prop-types';

class ImageEditor extends React.Component {
  static propTypes = {
    image: PropTypes.string,
    stopEditing: PropTypes.func.isRequired,
    cancelEditing: PropTypes.func.isRequired,
    handleFileChange: PropTypes.func.isRequired,
    imageTitle: PropTypes.string.isRequired
  }
  get defaultImageScale () { return 1 }
  constructor (props) {
    super(props)

    this.state = {
      imageScale: this.defaultImageScale,
      avatarEditorModalIsOpen: false,
      imagePreview: this.props.image
    }

    this.handleScale = this.handleScale.bind(this)
    this.updatePreview = this.updatePreview.bind(this)
    this.imageEditorCanvasRef = this.imageEditorCanvasRef.bind(this)
    this.stopEditing = this.stopEditing.bind(this)
    this.getImage = this.getImage.bind(this)
  }

  stopEditing () {
    this.setState({ imageScale: 1 })
    this.props.stopEditing(this.getImage())
  }

  handleScale = (e) => {
    const scale = parseFloat(e.target.value)
    this.setState({ imageScale: scale })
  }

  getImage () {
    const canvasScaled = this.imageEditorCanvas.getImageScaledToCanvas()
    return canvasScaled.toDataURL('image/jpeg')
  }

  updatePreview () {
    this.setState({ imagePreview: this.getImage() })
  }

  imageEditorCanvasRef (canvas) {
    this.imageEditorCanvas = canvas
  }

  render () {
    var editorStyle = {
      width: '100%',
      height: '100%'
    }
    const { image, handleFileChange } = this.props
    return <Row>
      <Col md={6}>
        <h3 className={styles['title']}>{this.props.imageTitle}</h3>
        <p>
          Drag the square to change position. <a className={styles['change-photo']} onClick={() => { this.imageInputRef.click() }} >Change photo</a>
        </p>
<div className={styles['avatar-editor-wrapper']}>
    <AvatarEditor
          onImageReady={this.updatePreview}
          onImageChange={this.updatePreview}
          onPositionChange={this.updatePreview}
          ref={this.imageEditorCanvasRef}
          image={image}
          width={300}
          height={300}
          rotate={0}
          scale={parseFloat(this.state.imageScale)}
          style={editorStyle}
        />
        </div>
        <Form.Group>
          <div className={styles['zoom-slider-container']}>
            <div className={styles['zoom-slider']}>
              <Row>
                <Col xs={2} sm={2} md={2} lg={2}>
                  <FontAwesome name='picture-o' size='2x' />
                </Col>
                <Col xs={7} sm={7} md={7} lg={7}>
                  <input className={styles['no-focus-shadow']} type='range' onChange={this.handleScale} min='0.1' max='2' step='0.01' defaultValue={this.state.imageScale} />
                </Col>
                <Col xs={3} sm={3} md={3} lg={3}>
                  <FontAwesome name='picture-o' size='3x' />
                </Col>
              </Row>
            </div>
          </div>
          <EditButton pullRight
            formIsValid
            submitting={false}
            editing
            stopEditing={this.stopEditing}
            cancelEditing={this.props.cancelEditing} />
        </Form.Group>
      </Col>
      <Col md={6}>
        <h3 className={styles['title']}>Preview</h3>
        <p>How you will appear on our platform</p>
        <img className={styles['profile-image']} src={this.state.imagePreview} />
        <div className={styles['avatar-photo']}>
          <FileUploader
            inputRef={(input) => { this.imageInputRef = input }}
            handleFileChange={handleFileChange} accept='image/*'
          />
        </div>
      </Col>
    </Row>
  }
}

export default (ImageEditor)
